export default "__VITE_PUBLIC_ASSET__1170f3f3__"